import { useMutationBuilder, useQueryBuilder } from "../../useBuilders";
import {
  DELETE,
  DOMAINS,
  FETCH,
  SEEK_INDEX,
  STORYBOARD,
  UNPUBLISH,
  UPDATE,
  WEBSITE_SETTINGS,
} from "../../queryKeys";
import { websiteSettingsApi } from "src/services/experiences/storyboardSettings/websiteSettings";

export const useStoryboardQuery = (id: string) => {
  return useQueryBuilder(
    [STORYBOARD, FETCH, id],
    () => websiteSettingsApi.fetchStoryboard(id),
    false,
    1 * 60 * 1000,
    "always",
    undefined,
    Boolean(id),
  );
};

export const useUpdateStoryboardMutation = () => {
  return useMutationBuilder(
    [WEBSITE_SETTINGS, UPDATE],
    websiteSettingsApi.updateStoryboard,
  );
};

export const useDomainsQuery = () => {
  return useQueryBuilder(
    [DOMAINS, FETCH],
    websiteSettingsApi.fetchDomains,
    false,
    5 * 60 * 1000,
    false,
  );
};

export const useUnpublishPageMutation = () => {
  return useMutationBuilder(
    [WEBSITE_SETTINGS, UNPUBLISH],
    websiteSettingsApi.unpublishPage,
    [STORYBOARD],
  );
};

export const useDeleteStoryboardMutation = () => {
  return useMutationBuilder(
    [WEBSITE_SETTINGS, DELETE],
    websiteSettingsApi.deleteStoryboard,
    [STORYBOARD],
  );
};

export const usePageSeekIndexMutation = () => {
  return useMutationBuilder(
    [WEBSITE_SETTINGS, SEEK_INDEX, "PAGE"],
    websiteSettingsApi.indexPageForSeek,
    [STORYBOARD],
  );
};

export const useStoryboardSeekIndexMutation = () => {
  return useMutationBuilder(
    [WEBSITE_SETTINGS, SEEK_INDEX, STORYBOARD],
    websiteSettingsApi.indexStoryboardForSeek,
    [STORYBOARD],
  );
};
